/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Geolocation
 */
export interface Geolocation {
    /**
     * 
     * @type {number}
     * @memberof Geolocation
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof Geolocation
     */
    longitude: number;
}

/**
 * Check if a given object implements the Geolocation interface.
 */
// @ts-ignore
export function instanceOfGeolocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "latitude" in value;
    isInstance = isInstance && "longitude" in value;

    return isInstance;
}

// @ts-ignore
export function GeolocationFromJSON(json: any): Geolocation {
    return GeolocationFromJSONTyped(json, false);
}

// @ts-ignore
export function GeolocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Geolocation {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

// @ts-ignore
export function GeolocationToJSON(value?: Geolocation | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latitude': value.latitude,
        'longitude': value.longitude,
    };
}

